import useSWR from 'swr'
import queryString from 'query-string'
import moment from 'moment'
import { formatDate } from '../../../../../utils/formatters'
import { ERROR_RETRY_SWR } from '../../../../../utils/constants'
import { RequestErrors } from '../../../../../components/Modals'

export const useDailyAttendance = (professionalId, date, revalidateOnFocus = false) => {
  const query = {
    start: formatDate({ date: moment(date).startOf('month'), format: 'DD-MM-YYYY' }),
    end: formatDate({ date, format: 'DD-MM-YYYY' })
  }

  const url = `${process.env.REACT_APP_SCHEDULER_URL}/report/professional/${professionalId}/attendances-history?${queryString.stringify(query,
    { arrayFormat: 'bracket' })}`

  const { data, error } = useSWR(url, { revalidateOnFocus, errorRetryCount: ERROR_RETRY_SWR })

  if (error) {
    RequestErrors('/dashboard')
    return
  }

  return data
}
